import React from 'react';
import cls from 'classnames';

import { DividerProps, DividerOrientation } from './Divider.types';

const Divider: React.FC<DividerProps> = (props) => {
	const className =
		props.orientation === DividerOrientation.Vertical
			? 'divider-vertical'
			: 'divider-horizontal';
	return <hr className={cls(className, props.className)} />;
};

export default Divider;
